
<div
    [@toastMessageTrigger]="(_toastmessageService.showsToast$ | async) ? 'open' : 'close'"
    [class]="_toastmessageService.toastState$ | async"
>
    <div style="max-width: 160px">
        <mat-icon>{{_toastmessageService.matIcon$ | async}}</mat-icon>
        <span>{{ _toastmessageService.toastMessage$ | async }}</span>
    </div>

    <a (click)="dismiss()" class="close-btn" (click)="showsToast = !showsToast">
        <mat-icon>close</mat-icon>
    </a>
</div>
